/* global process */
import axios from 'axios';

const baseURL = process.env.VUE_APP_API_VERSION === 'dev' ? process.env.VUE_APP_SSO_URL : `${window.location.origin}/`;

const ssoAPI = axios.create({
  baseURL,
});

ssoAPI.defaults.headers['x-api-key'] = process.env.VUE_APP_TOKEN_API_KEY;
ssoAPI.defaults.headers['x-client-version'] = process.env.VUE_APP_CLIENT_VERSION;

export default ssoAPI;
